import React from 'react';
import { useGetList } from 'react-admin';
import { Link } from 'react-router-dom';
import {
	Card,
	CardContent,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';

const fmt = (d?: string) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

// LastBillingAccounts : les 10 derniers comptes créés, avec leur nature.
//
// ⚠️ Tri sur `created_at` et non sur l'id : celui d'un compte est un UUID, donc
// sans ordre chronologique — trier dessus donnerait dix comptes au hasard.
//
// Pas d'endpoint dédié : la liste admin sait déjà trier et paginer.
export const LastBillingAccounts: React.FC = () => {
	const { data, isLoading, error } = useGetList('billing-accounts', {
		pagination: { page: 1, perPage: 10 },
		sort: { field: 'created_at', order: 'DESC' },
	});

	return (
		<Card sx={{ height: '100%' }}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Derniers comptes créés
				</Typography>
				{error && (
					<Typography variant="body2" color="error">
						Chargement impossible
					</Typography>
				)}
				{isLoading && !error && (
					<Typography variant="body2" color="text.secondary">
						Chargement…
					</Typography>
				)}
				{!isLoading && !error && !data?.length && (
					<Typography variant="body2" color="text.secondary">
						Aucun compte
					</Typography>
				)}
				{!!data?.length && (
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Compte</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Créé le</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((ba: any) => (
								<TableRow key={ba.id} hover>
									<TableCell>
										<Link to={`/billing-accounts/${ba.id}`}>{ba.name || '(sans nom)'}</Link>
									</TableCell>
									<TableCell>
										{ba.billingMode === 'contract' ? (
											<Chip size="small" color="primary" label="Entreprise" />
										) : (
											<Chip size="small" label="Pay as you go" />
										)}
										{ba.isFree && (
											<Chip size="small" variant="outlined" label="Free" sx={{ ml: 0.5 }} />
										)}
									</TableCell>
									<TableCell>{fmt(ba.createdAt)}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				)}
				<Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
					<Link to="/billing-accounts">Voir tous les comptes</Link>
				</Typography>
			</CardContent>
		</Card>
	);
};
